import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';


export default function SubField({ category, categoryFields, displayOptions }) {
  // Sort an array of objects by strings
  // https://www.javascripttutorial.net/array/javascript-sort-an-array-of-objects/
  categoryFields.sort((a, b) => {
    let fa = a.field_name.toLowerCase(),
        fb = b.field_name.toLowerCase()
    if (fa < fb) {
        return -1
    }
    if (fa > fb) {
        return 1
    }
    return 0
  })
  // console.log(sortedCategoryFields)
  return (
    <Container className='boostrapContainer mb-3 pb-1 rounded'>
      <Row>
        <Col>
          <h5>{category.slice(3)}</h5>
          <hr style={{margin: '0 0 1rem 0'}}/>
        </Col>
      </Row>
      {
        categoryFields.map((categoryField) => {
          return (
            <Row key={`row-${categoryField.field_name}`} className='boostrapRow px-3 py-3'>
              <Col xs={3} style={{fontFamily: 'Circular Bold'}}>
                <p style={{margin: 0}}>{categoryField.field_name}</p>
                <p style={{fontFamily: 'Circular Book, Geneva, Verdana, sans-serif', margin: 0}}>
                  {categoryField.field_type !== null && categoryField.field_type} <span>id# {categoryField.id}</span>
                </p>
              </Col>
              <Col xs={6}>
                {/* <p style={{marginBottom: 5}}>
                  <Button variant="outline-primary" onClick={() => {
                      navigator.clipboard.writeText(categoryField.sf_lead_name)
                    }}>
                    {categoryField.sf_lead_name}
                  </Button>
                </p> */}
                <p style={{marginBottom: 5}}>
                  <Button
                    style={{fontSize: '14px'}}
                    variant="outline-success"
                    onClick={() => navigator.clipboard.writeText(categoryField.sf_application_name)}
                  >
                    {categoryField.sf_application_name}
                  </Button>
                </p>
              </Col>
              <Col xs={3}>
                {
                  displayOptions(categoryField).map((option) => {
                    return <p key={`${categoryField.id}-${option}`} style={{marginBottom: 3}}>
                      <Button
                        style={{fontSize: '14px'}}
                        variant="outline-light"
                        onClick={() =>  navigator.clipboard.writeText(option)}
                      >
                        {option}
                      </Button>
                    </p>
                  })
                }
              </Col>
            </Row>
          )
        })
      }
    </Container>
  )
}
